import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Outlet } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { FormControl } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "../style/Layout.css";

const Layout = () => {
  const handleWatchNow = () => {
    window.open(`https://www.themoviedb.org/movie/`, "_blank");
  };
  return (
    <>
      <Navbar bg="light" expand="md" className="nav-bar">
        <Navbar.Brand href="/">R.Ajeti</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/" className="anchor">
              Home
            </Nav.Link>
            <Nav.Link href="services" className="anchor">
              Services
            </Nav.Link>
            <Nav.Link href="aboutus" className="anchor">
              About
            </Nav.Link>
            <Nav.Link href="login" className="anchor">
              Login
            </Nav.Link>
            <Nav.Link href="contactform" className="anchor">
              Contact
            </Nav.Link>
          </Nav>
          <Form className="d-flex">
            <FormControl type="text" placeholder="Search" className="me-2" />
            <Button className="btn-search" onClick={handleWatchNow}>
              Search
            </Button>
          </Form>
        </Navbar.Collapse>
      </Navbar>
      <Outlet />
    </>
  );
};

export default Layout;
